import { render, staticRenderFns } from "./Liucheng.vue?vue&type=template&id=75089983&scoped=true&"
import script from "./Liucheng.vue?vue&type=script&lang=js&"
export * from "./Liucheng.vue?vue&type=script&lang=js&"
import style0 from "./Liucheng.vue?vue&type=style&index=0&id=75089983&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75089983",
  null
  
)

export default component.exports